import useListDisplayState from "@hooks/useListDisplayState"

import { useSelectContext } from "@molecules/Select/Select.context"

import { SelectNoResultsProps } from "./SelectNoResults.types"

export default function SelectNoResults(props: SelectNoResultsProps) {
    const { children, filteredCount: filteredCountOverride } = props
    const { searchData } = useSelectContext()

    const isLoading = searchData?.isLoading ?? false
    const isFetching = searchData?.isFetching ?? false
    const isFetchingNextPage = searchData?.isFetchingNextPage ?? false
    const isTyping = searchData?.searchState.isTyping ?? false
    const hasSearchTerm = searchData?.searchState.hasSearchTerm ?? false
    const itemCount = searchData?.results.length ?? 0
    const filteredCount = filteredCountOverride ?? itemCount

    const { showNoResults } = useListDisplayState({
        isLoading,
        isFetching,
        isFetchingNextPage,
        isTyping,
        itemCount,
        filteredCount,
        hasSearchTerm,
    })

    if (!searchData || !showNoResults || searchData?.isError) {
        return null
    } else {
        return <>{children}</>
    }
}
